module.exports = "/dist/montserrat-latin-300italic.svg?26aacd289eec044d31f88c44297f54ba";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300italic.svg
// module id = 71
// module chunks = 0